import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { DataService } from '../shared/dataservice.service';
import { GenService } from '../shared/gen-ser.service';
import { DailyProdHighlights, CCRPStatusMonitoring, FooterData, InprocessQualityIssues, ProductionStatusMonitoring, TaskAllocation,PoleStockReview, MaterialShortage, CustomerInspectionPlan, DailyDeliveryPlan, GreenStickerPlan } from '../shared/misc-classes';
import { INTERNAL_BROWSER_PLATFORM_PROVIDERS } from '@angular/platform-browser/src/browser';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { DomSanitizer } from '@angular/platform-browser'

// @Pipe({ name: 'safeHtml'})
@Component({
  selector: 'app-summary-page',
  templateUrl: './summary-page.component.html',
  styleUrls: ['./summary-page.component.css']
})
export class SummaryPageComponent implements OnInit {
  currMonthDtObj:Date = new Date();

  ccrpdatatables:CCRPStatusMonitoring;
  dProdHighObj: DailyProdHighlights;
  inProcessQualObj:InprocessQualityIssues;
  prodStatusObj:ProductionStatusMonitoring;
  tskAllctn:TaskAllocation;
  poleStkRvw:PoleStockReview;
  mtrlShrtge:MaterialShortage;
  cstInspPln:CustomerInspectionPlan;
  dlyDlvryPln:DailyDeliveryPlan;
  grnInspPln:GreenStickerPlan;
  footerData:FooterData;
  productLine:string = '';
  mId:string = "75d6c01a-ca1e-4bf2-6a07-496509cba968"
  

  constructor(public _dataService:DataService,private _router:Router, private _notify:NotificationsService) { }

  ngOnInit() {
    this.currMonthDtObj = new Date();
    this.loadDateData();
  }
  routePage(link){
    this._router.navigate([link])
  }
  loadDateData(){
    this.loadCCRPData();
    this.loadDailyProd();
    this.loadInprocessQual(this.productLine);
    this.loadProdStatus();
    this.loadManPwrAlctn();
    setTimeout(() => {
      this.loadFooterData();  
    }, 300);
    
    //this.loadMtrlShrtge();
   // this.loadCustInspPlan();
   // this.loadDailyDlvryPlan();
   // this.loadGrnStkrPlan();
  }
  sendGembaMoM(){
    this._dataService.sendGembaMoM(this.currMonthDtObj).subscribe((_docid) => {
      if(_docid==""){
        this._notify.error('Failure','Failed to sent email.',this._dataService.failureOptions);
      }
      else{
        this._notify.success('Success','Mail Sent.',this._dataService.successOptions);
      }
    })
  }
  prevDateSel():void{
    //if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
    //}
  }
  nextDateSel():void{
    //var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    //if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();
    //}
  }
  loadGrnStkrPlan(){
    this._dataService.loadGreenStickerPlan(this.currMonthDtObj).subscribe((_cstInspPlan: GreenStickerPlan) => {
      if (_cstInspPlan != null) {
        this.grnInspPln = _cstInspPlan;
      }
    });
  }
  loadDailyDlvryPlan(){
    this._dataService.loadDailyDeliveryPlan(this.currMonthDtObj).subscribe((_dailyDeliveryPlan:DailyDeliveryPlan) => {
      if(_dailyDeliveryPlan!=null){
        this.dlyDlvryPln = _dailyDeliveryPlan;
      }
    });
  }
  loadCustInspPlan(){
    this._dataService.loadCustmrInspPlan(this.currMonthDtObj).subscribe((_cstInspPlan:CustomerInspectionPlan) => {
      if(_cstInspPlan!=null){
        this.cstInspPln = _cstInspPlan;
      }
    });
  }
  loadMtrlShrtge(){
    this._dataService.loadMaterialShortage(this.currMonthDtObj).subscribe((_dataTables:MaterialShortage) => {
      if(_dataTables!=null){
        this.mtrlShrtge = _dataTables;
      }
    });
  }
  loadFooterData(){
    this._dataService.loadFooterData().subscribe((_cstInspPlan:FooterData) => {
      if(_cstInspPlan!=null){
        this.footerData = _cstInspPlan;
        //console.log(this.footerData)
      }
    });
  }
  loadManPwrAlctn(){
    this._dataService.loadManPowerAllocation(this.currMonthDtObj).subscribe((_cstInspPlan:TaskAllocation) => {
      if(_cstInspPlan!=null){
        this.tskAllctn = _cstInspPlan;
      }
    });
  }
  loadPoleStkRevw(){
    this._dataService.loadPoleStockRevw(this.currMonthDtObj).subscribe((_cstInspPlan:PoleStockReview) => {
      if(_cstInspPlan!=null){
        this.poleStkRvw = _cstInspPlan;
      }
    });
  }
  loadInprocessQual(prodline){
    this._dataService.loadinprocessqualityissues(this.currMonthDtObj,prodline).subscribe((_cstInspPlan:InprocessQualityIssues) => {
      if(_cstInspPlan!=null){
          this.inProcessQualObj = _cstInspPlan;
      }
    });
  }
  loadCCRPData(){
    this._dataService.loadCCRPStatusMonitoring(this.currMonthDtObj).subscribe((_cstInspPlan:CCRPStatusMonitoring) => {
      if(_cstInspPlan!=null){
        this.ccrpdatatables = _cstInspPlan;
      }
      else{
        this.ccrpdatatables = null;
      }
    });
  }
  loadDailyProd(){
    this._dataService.loadDailyProdHighlights(this.currMonthDtObj).subscribe((_dailyProdHigh: DailyProdHighlights) => {
      if (_dailyProdHigh != null) {
        this.dProdHighObj = _dailyProdHigh;
      }
    });
  }
  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }
  loadProdStatus(){
    this._dataService.loadProdStatusMontring(this.currMonthDtObj).subscribe((_Prod:ProductionStatusMonitoring) => {
      if(_Prod!=null){
        this.prodStatusObj = _Prod;
      }
    });
  }
}
